import React from 'react';
import { withRouter } from '../../common/withRouter';
import { connect } from 'react-redux';
import { ButtonOBSOLETED, Notification } from '../../web.common';
import { Message } from '../../web.common/src/components/lists/SystemMessages';
import { LayoutContext } from '../layout/siteLayout';
import PageTop from '../layout/PageTop';
import withApi from '../higherOrderComponents/withApi';

class DevelopersInternal extends React.Component {
  constructor() {
    super();

    this.state = {
      errorMessage: null
    };
  }

  render() {
    return (
      <LayoutContext.Consumer>
        {() => {
          const { api } = this.props;
          const {
            errorMessage,
            cleaningOldAcivities,
            executingRebuildFacilitiesIndex,
            runningBookingCheck
          } = this.state;

          const {
            activities: {
              cleanOldActivities,
              runBookingCheck
            }
          } = api;

          return (
            <div className='content-width-limiter-narrow'>
              <Notification newMessage={errorMessage} />
              <PageTop
                documentTitle='Developers page'
                documentDescription='Developers page'
              />
              <br />
              <br />
              <ButtonOBSOLETED
                disabled={cleaningOldAcivities}
                onClick={async () => {
                  this.setState({
                    cleaningOldAcivities: true
                  });

                  try {
                    var result = await cleanOldActivities();

                    this.setState({
                      cleaningOldAcivities: false,
                      errorMessage: new Message('success', `cleaned ${result} activities`)
                    });
                  }
                  catch (e) {
                    this.setState({
                      cleaningOldAcivities: false,
                      errorMessage: new Message('error', JSON.stringify(e))
                    });
                    return;
                  }

                  
                }}
                type='button'
                className='button button-primary button-full-width'
                buttonContent='Clean Old Activities'
                ariaLabel='Clean Old Activities'
              />
              <br />
              <br />
              <ButtonOBSOLETED
                disabled={runningBookingCheck}
                onClick={async () => {
                  this.setState({
                    runningBookingCheck: true
                  });

                  var result = await runBookingCheck();

                  if(result.success){
                    this.setState({
                      runningBookingCheck: false,
                      errorMessage: new Message('success', `booking check run correctly`)
                    });
                  }else{
                    this.setState({
                      runningBookingCheck: false,
                      errorMessage: new Message('error', JSON.stringify(e))
                    });
                    return;
                  }
                }}
                type='button'
                className='button button-primary button-full-width'
                buttonContent='Run Booking Check'
                ariaLabel='Run Booking Check'
              />
            </div>
          );
        }}
      </LayoutContext.Consumer>
    );
  }
}

const Developers = withApi(withRouter(
  connect(({ user }) => ({ isLoggedIn: !!user, user }), {})(DevelopersInternal)));
Developers.requiresLogin = true;

export default Developers;